import React from "react";
import { useIntl } from "react-intl";
import { StoreLayout } from "components/store-layout/StoreLayout";
import { StoreCard } from "toolkit/card/StoreCard";
import { Col, Result, Row, Space } from "antd";
import { CheckOutlined } from "@ant-design/icons";

import "./RequestSubscriptionSuccessPage.less";

export function RequestSubscriptionSuccessPage() {
  const intl = useIntl();

  return (
    <StoreLayout>
      <StoreCard className="academic-result-page">
        <Row
          className="academic-result-page__content"
          justify="space-around"
          align="middle"
        >
          <Col>
            <Space direction="vertical" align="center">
              <Result
                icon={<CheckOutlined className="academic-result-page_check-icon" />}
                title={intl.formatMessage({ id: "jmix-store.request-success-page.title" })}
                subTitle={intl.formatMessage({ id: "jmix-store.request-success-page.sub-title" })}
              />
            </Space>
          </Col>
        </Row>
      </StoreCard>
    </StoreLayout>
  );
}